import React, { useState } from 'react';
import { observer } from 'mobx-react';
import { RouteComponentProps } from 'react-router';
import routes from 'routes';
import BaseContainer from 'app/containers/BaseContainer';
import Panel from 'app/components/Panel';
import { AnonymousMainMenu } from '../AnonymousMainMenu';
import { AspTimeline } from './AspTimeline';
import { AspPotentialListe } from './AspPotentialListe';
import { AspAgtDashboard } from './AspAgtDashboard';
import { AspJpgIntegration } from './AspJpgIntegration';
import { AspAgtListe } from './AspAgtListe';
import { IAspAgt } from './asp.mock.data';

export const AspTimelineDesign = observer((props: RouteComponentProps) => {
	return (
		<BaseContainer sideMenu={<AnonymousMainMenu {...props} />} navbar={<div>ASP Übersicht</div>}>
			<AspTimeline />
		</BaseContainer>
	);
});

export const AspPotentialListeDesign = observer((props: RouteComponentProps) => {
	return (
		<BaseContainer sideMenu={<AnonymousMainMenu {...props} />} navbar={<div>ASP Potentialliste</div>}>
			<AspPotentialListe />
		</BaseContainer>
	);
});

export const AspAgtDashboardDesign = observer((props: RouteComponentProps) => {
	const [selectedAgt, setSelectedAgt] = useState<IAspAgt>({ agtId: 47119024, name: 'Müller & Partner OHG' });

	const onClose = () => {
		props.history.push(routes.DESIGN.getPath());
	};
	return (
		<BaseContainer sideMenu={<AnonymousMainMenu {...props} />} navbar={<div>Agenturen</div>}>
			<Panel title={selectedAgt.name} subtitle={selectedAgt.agtId.toString()} header={<></>} onClose={onClose}>
				<AspAgtDashboard />
			</Panel>
			<AspAgtListe selectedAgtId={selectedAgt.agtId} onSelectAgt={setSelectedAgt} />
		</BaseContainer>
	);
});

export const AspJpgIntegrationDesign = observer((props: RouteComponentProps) => {
	return (
		<BaseContainer sideMenu={<AnonymousMainMenu {...props} />} navbar={<div>JPG mit ASP</div>}>
			<AspJpgIntegration />
		</BaseContainer>
	);
});
